import React from 'react'
import Slider from 'react-slick'
import { Box, Button, Fade, Typography } from '@mui/material'
import { TypeAnimation } from 'react-type-animation'
import { NextArrow, PrevArrow } from './carouselArrows'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './carousel.css'
import header from '../../_content/paving4.webp'
import header2 from '../../_content/IMG_3317.webp'

const HomepageCarousel = ({ navigateLink }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  const images = [header, header2]

  return (
    <Box className="carousel-container">
      <Slider {...settings}>
        {images.map((img, index) => (
          <Box key={index} className="carousel-slide">
            <Box
              className="carousel-image"
              sx={{
                backgroundImage: `url(${img})`,
                height: { xs: '40vh', sm: '60vh', md: '80vh' },
              }}
            >
              <Box
                className="headerTypography"
                sx={{
                  position: 'relative',
                  zIndex: 2,
                  textAlign: 'center',
                  maxWidth: '800px',
                  px: 2,
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    color: 'white',
                    fontWeight: 700,
                    fontSize: {
                      xs: '1.6rem',
                      sm: '2.2rem',
                      md: '2.8rem',
                    },
                    textShadow: '0 2px 8px rgba(0,0,0,0.6)',
                    minHeight: {
                      xs: '40px',
                      sm: '60px',
                      md: '70px',
                    },
                  }}
                >
                  <TypeAnimation
                    sequence={[
                      '',
                      1000,
                      'Read Landscaping',
                    ]}
                    speed={200}
                    cursor={false}
                    repeat={0}
                  />
                </Typography>

                <Fade
                  in
                  timeout={2200}
                >
                  <Box>
                    <Typography
                      variant="h4"
                      sx={{
                        color: 'white',
                        fontWeight: 600,
                        mt: 3,
                        fontSize: {
                          xs: '1rem',
                          sm: '1.4rem',
                          md: '1.8rem',
                        },
                        textShadow: '0 2px 8px rgba(0,0,0,0.6)',
                      }}
                    >
                      Professional landscaping and garden maintenance services,
                      based in Essex
                    </Typography>

                    <Button
                      size="large"
                      sx={{
                        backgroundColor: '#015f44',
                        color: 'white',
                        mt: 4,
                        px: 4,
                        py: 1.5,
                        textTransform: 'none',
                        fontSize: '1rem',

                        '&:hover': {
                          backgroundColor: '#8FAA30',
                        },
                      }}
                      onClick={() => navigateLink('/contact')}
                    >
                      Get a free quote today!
                    </Button>
                  </Box>
                </Fade>
              </Box>
            </Box>
          </Box>
        ))}
      </Slider>
    </Box>
  )
}

export default HomepageCarousel
